import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from './../../../_services/common.service';
import {HttpRequestService} from './../../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-topic-landing',
  templateUrl: './topic-landing.component.html',
  styleUrls: ['./topic-landing.component.scss']
})
export class TopicLandingComponent implements OnInit {
  topicList:any = {
    leftPart:[],
    rightPart:[]
  };
  constructor(public translate: TranslateService,private cService: CommonService,
    private httpService: HttpRequestService, private toastr: ToastrService,) {
    this.cService.activelang.subscribe((lang) => {

      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(lang);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(lang);
    });

  }

  ngOnInit() {
    this.httpService.setModule('action').post('topic_list',{}).subscribe((response) => {

      if (response.status == 'success') {
        if (response.data.data.length > 0) {
          if (response.data.data.length > 10) {
            let midIndex = response.data.data.length/2;
            this.topicList.leftPart = response.data.data.slice(0,midIndex);
            this.topicList.rightPart = response.data.data.slice(midIndex+1);
          } else {
            this.topicList.leftPart = response.data.data;
          }
        }
      }
      if (response.status=='error') {
        this.toastr.error( response.data,'Login');
      }
    }, (error) => {
      console.log(error);
    });
  }

}
